import { render } from "./ModalBulkPriceUpdate.vue?vue&type=template&id=9984cf5a&scoped=true"
import script from "./ModalBulkPriceUpdate.vue?vue&type=script&lang=js"
export * from "./ModalBulkPriceUpdate.vue?vue&type=script&lang=js"

import "./ModalBulkPriceUpdate.vue?vue&type=style&index=0&id=9984cf5a&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9984cf5a"]])

export default __exports__